import React from 'react'
import { useTranslation } from 'react-i18next'

import { Timeline } from '@mui/icons-material'
import { Button, ButtonProps, SvgIconProps } from '@mui/material'

import { GRTooltip } from '../GRTooltip/GRTooltip'

type Props = ButtonProps & {
  iconProps?: SvgIconProps
  showText?: boolean
}

export const GamePerformanceDialogOpenButton: React.FC<Props> = ({ showText, iconProps, ...iconButtonProps }) => {
  const { t } = useTranslation()
  const tooltipText = showText && iconButtonProps.disabled ? t('live-events:performance_non_mobile_games_tooltip_text') : t('top-games:show_performance')

  return (
    <GRTooltip content={tooltipText}>
      <Button
        color="primary"
        className="GamePerformanceDialogOpenButton"
        sx={showText ? undefined : { minWidth: 0, width: 32, height: 32 }}
        {...iconButtonProps}
      >
        <Timeline {...iconProps} sx={showText ? { mr: '8px', ml: '-2px' } : undefined} />
        {showText && t('common:performance')}
      </Button>
    </GRTooltip>
  )
}
